module.exports = ".mb-3,\n.my-3 {\n  margin-bottom: 2rem !important; }\n"